// Animated avatar frame layers (pure CSS, see .pz-* in globals.css). Used inside <Avatar> and in the Prize store previews.
// Parent must be position: relative with font-size = its pixel size (.avatar-frame already is).
import { getPrize } from '@/lib/prizes'
import { PosterIcon, EmojiPoster } from '@/components/poster-icons'

export function PrizeFrameLayers({ id }: { id?: string }) {
  const p = getPrize(id)
  if (!p || p.type !== 'frame') return null
  return (
    <>
      <span className={`pz-glow pz-fr-${p.id}`} aria-hidden="true" />
      <span className={`pz-ring pz-fr-${p.id}`} aria-hidden="true" />
    </>
  )
}

/** Name badge chip (emoji + label), coloured by rarity. */
export function PrizeBadge({ id }: { id?: string }) {
  const p = getPrize(id)
  if (!p || p.type !== 'badge') return null
  return (
    <span className={`pz-badge pz-r-${p.rarity}`} title={p.name}>
      <span className="pz-badge-e" aria-hidden="true"><EmojiPoster char={p.emoji || ''} size={16} /></span>{p.name}
    </span>
  )
}

/** Animated profile banner; fills its (position: relative / overflow: hidden) parent. */
export function PrizeBanner({ id }: { id?: string }) {
  const p = getPrize(id)
  if (!p || p.type !== 'banner') return null
  return <div className={`pz-banner pz-bn-${p.id}`} aria-hidden="true" />
}

const GRADIENT_NAMES = ['nf-ice', 'nf-gold', 'nf-fire', 'nf-rainbow', 'nf-galaxy']
/** Animated name style (glow, neon, gold shine, fire...). Renders plain children when no effect is equipped. */
export function NameFx({ id, children }: { id?: string; children: React.ReactNode }) {
  const p = getPrize(id)
  if (!p || p.type !== 'namefx') return <>{children}</>
  return <span className={`pz-nfx pz-nfx-${p.id}${GRADIENT_NAMES.includes(p.id) ? ' pz-nfx-g' : ''}`}>{children}</span>
}
